import { withTranslation } from "react-i18next";

import { DropDownStyled, IconSection } from "./DropDown.styled";

// Own Component
import Text from "../../Components/Text";
import Icon from "../Icon";
import { tDropDown } from "../../Models/DropDown";

const DropDown = ({
  handleColapse,
  handleDelete,
  index,
  showList,
  title,
}: tDropDown) => {
  return (
    <DropDownStyled>
      <Text size={3} color="Eerie_Black" align="left" weight={600}>
        {title} {index + 1}
      </Text>
      <IconSection>
        <Icon
          icon={showList ? "chevronUp" : "chevronDown"}
          size="medium"
          color="black"
          onClick={handleColapse}
        />
        <Icon
          icon={"trash"}
          size="medium"
          color="black"
          onClick={handleDelete}
        />
      </IconSection>
    </DropDownStyled>
  );
};

export default withTranslation("ns")(DropDown);
